import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", fontFamily: "var(--font-d)", color: "#5d6f8c" }}>Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
